'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true,
});
exports.default = void 0;

var _react = require('react');

var _core = require('@material-ui/core');

var _jsxRuntime = require('react/jsx-runtime');

var ConfirmationDialog = function ConfirmationDialog(_ref) {
  var open = _ref.open,
    onToggle = _ref.onToggle,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    children = _ref.children;

  var handleClose = function handleClose() {
    onToggle(false);
  };

  return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_core.Dialog, {
    open: open,
    onClose: handleClose,
    children: [
      /*#__PURE__*/ (0, _jsxRuntime.jsx)(_core.DialogTitle, {
        children: title,
      }),
      /*#__PURE__*/ (0, _jsxRuntime.jsx)(_core.DialogContent, {
        children: children,
      }),
      /*#__PURE__*/ (0, _jsxRuntime.jsx)(_core.DialogActions, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_core.Button, {
          color: 'primary',
          variant: 'contained',
          onClick: handleClose,
          children: 'Confirm',
        }),
      }),
    ],
  });
};

var _default = /*#__PURE__*/ (0, _react.memo)(ConfirmationDialog);

exports.default = _default;

//# sourceMappingURL=index.js.map
